import * as React from "react";

export default class Payment extends React.Component<any, any> {
  componentDidMount() {
    this.props.setBreadCrumbs([]);
  }
  render() {
    return (
      <div>
        Payment
      </div>
    );
  }
}
